/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import classNames from 'classnames/bind';
import { Row, Col, Select } from 'antd';
import { DEFAULT_DATE_SETTING } from 'config/app.config';
import { setTaskStatusQueryText, setPeriod, queryByPeriod, setTaskStatus, setActiveMember, queryFetch, queryByCondition } from '../flow/action';
import { ALL_STATUS } from '../flow/config';
import { getDefautTaskStatus } from '../flow/reselect';
import styles from '../index.less';
import DateRangeModel from './DateRangeModel';

const { END_DATE_FORMAT } = DEFAULT_DATE_SETTING;
const cx = classNames.bind(styles);

const { Option } = Select;

class TopActions extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedTaskStatus: [],
      selectedTaskPriority: [],
      selectedMembers: [],
      visible: false,
      selectedPeriod: '',
    };
  }

  async componentDidMount() {
    const {
      defaultTaskStatus, loginUser
    } = this.props;
    const { selectedMembers } = this.state;
    // setting default action period
    const { selectedStatus } = this.props;
    this.setState({
      selectedPeriod: selectedStatus,
    });
    if (loginUser) {
      this.props.setActiveMember(loginUser.id);
      this.setState({
        selectedMembers: [loginUser.name]
      });
    }
    if (!_.isEmpty(defaultTaskStatus) && selectedMembers.length === 0) {
      await this.setState({
        selectedTaskStatus: defaultTaskStatus,
        selectedMembers: [loginUser.name]
      });
      this.props.queryByCondition({
        memberIds: loginUser.id
      });
    }
  }

  async componentDidUpdate(prevProps) {
    const {
      defaultTaskStatus,
      loginUser,
      teamMembers: { members },
    } = this.props;
    const { selectedMembers } = this.state;
    if (
      !_.isEqual(prevProps.defaultTaskStatus, defaultTaskStatus) &&
      selectedMembers.length &&
      members
    ) {
      await this.setState({
        selectedTaskStatus: defaultTaskStatus,
        selectedMembers: [loginUser.name]
      });
      this.handleMultipleSelect();
    }
  }

  // set period value
  setStatePeriod = (val) => {
    this.setState({
      selectedPeriod: val
    });
  }

  valueToString = value => value.join(',').trim();

  handleMultipleSelect = () => {
    const { selectedTaskStatus, selectedTaskPriority, selectedMembers } = this.state;
    const {
      taskStatusOptions,
      taskPriorityOptions,
      teamMembers: { members },
    } = this.props;
    const selectedStatusId = selectedTaskStatus.map(val => {
      const selectedOption = taskStatusOptions.find(option => option.display_value === val);
      return selectedOption ? selectedOption.id : '';
    });
    const selectedPriorityId = selectedTaskPriority.map(val => {
      const selectedOption = taskPriorityOptions.find(option => option.display_value === val);
      return selectedOption ? selectedOption.id : '';
    });
    const selectedMemberIds = selectedMembers.map(val => {
      const selectedOption = members.find(option => option.name === val);
      return selectedOption ? selectedOption.id : '';
    });
    const taskStatusText = this.valueToString(selectedStatusId);
    this.props.setTaskStatusQueryText(taskStatusText);
    this.props.setActiveMember(selectedMemberIds);
    this.props.queryByCondition({
      status: taskStatusText,
      priority: this.valueToString(selectedPriorityId),
      memberIds: selectedMemberIds
    });
  }

  handleTagsDelete = async (value, selectedKey) => {
    const selectedValue = this.state[selectedKey];
    const deletedValue = selectedValue.filter(v => v !== value);
    await this.setState({ [selectedKey]: deletedValue });
    this.handleMultipleSelect();
  }

  handleMultipleChange = (value, selectedKey) => {
    const selectedValue = this.state[selectedKey];
    const prevHasAll = selectedValue.some(v => v === 'All');
    const hasAll = value.some(v => v === 'All');
    if (hasAll && !prevHasAll) {
      this.setState({ [selectedKey]: ['All'] });
    } else if (hasAll && prevHasAll) {
      const parseValue = value.filter(v => v !== 'All');
      this.setState({ [selectedKey]: parseValue });
    } else {
      this.setState({ [selectedKey]: value });
    }
  }


  // Open Date Range Picker
  handleOpen = () => {
    this.setState({ visible: true });
  }

  // closes the modal
  handleCancel = () => {
    this.setState({ visible: false });
  }

  async handlePeriodChange(period) {
    let start = '';
    let end = '';
    let overDue = '';
    this.props.setTaskStatus(period);
    this.setStatePeriod(period);
    switch (period) {
      case ALL_STATUS.OVERDUE_TODAY:
        start = moment().format(END_DATE_FORMAT);
        end = start;
        overDue = true;
        break;
      case ALL_STATUS.OVERDUE:
        start = '';
        end = '';
        overDue = true;
        break;
      case ALL_STATUS.TOMORROW:
        start = moment().add(1, 'days').format(END_DATE_FORMAT);
        end = start;
        overDue = false;
        break;
      case ALL_STATUS.THIS_WEEK:
        start = moment().startOf('isoweek').format(END_DATE_FORMAT);
        end = moment().endOf('isoweek').format(END_DATE_FORMAT);
        overDue = false;
        break;
      case ALL_STATUS.ALL:
        start = '';
        end = '';
        overDue = false;
        break;
      case ALL_STATUS.THIS_MONTH:
        start = moment().startOf('months').format(END_DATE_FORMAT);
        end = moment().endOf('months').format(END_DATE_FORMAT);
        overDue = false;
        break;
      case ALL_STATUS.TODAY:
        start = moment().format(END_DATE_FORMAT);
        end = start;
        overDue = false;
        break;
      case ALL_STATUS.CUSTOMIZE:
        // trigger modal even if the same element is selected
        this.setStatePeriod('Range...');
        return this.handleOpen();
      default:
        break;
    }
    await this.props.setPeriod(start, end, overDue);
    return this.handleMultipleSelect();
  }

  render() {
    const {
      taskDataTablePagination,
      teamMembers: { members },
      taskStatusOptions,
      taskPriorityOptions,
    } = this.props;
    const { selectedTaskStatus, selectedTaskPriority, selectedMembers } = this.state;

    // sort dropdown member selector list in alphabetical order
    const membersOrderedByAlpha = members.sort((a, b) => (a.name.toLowerCase()).localeCompare(b.name.toLowerCase()));

    return (
      <Row
        type="flex"
        justify="start"
        align="middle"
        gutter={4}
      >
        <DateRangeModel
          visible={this.state.visible}
          handleCancel={this.handleCancel}
          handleMultipleSelect={this.handleMultipleSelect}
          setPeriod={this.props.setPeriod}
        />
        <Col span={2}>
          <Select
            className="full-width"
            value={this.state.selectedPeriod}
            onChange={val => this.handlePeriodChange(val)}
          >
            {
              Object.keys(ALL_STATUS).map(key => (
                <Option value={ALL_STATUS[key]} key={key}>
                  <FormattedMessage id={`page.task.${key}`} />
                </Option>
              ))
            }
          </Select>
        </Col>
        <Col span={2}>
          <Select
            className={classNames('full-width', 'taskList')}
            mode="multiple"
            tokenSeparators={[',']}
            value={selectedMembers}
            onChange={value => this.handleMultipleChange(value, 'selectedMembers')}
            onBlur={this.handleMultipleSelect}
            onDeselect={value => this.handleTagsDelete(value, 'selectedMembers')}
          >
            <Option key="All">
              <FormattedMessage id="page.task.allMembers" />
            </Option>
            {_.isArray(membersOrderedByAlpha) && membersOrderedByAlpha.map(memberOption => (
              <Option key={memberOption.name}>
                {memberOption.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={2}>
          <Select
            className={classNames('full-width', 'taskList')}
            mode="multiple"
            tokenSeparators={[',']}
            value={selectedTaskStatus}
            onChange={value => this.handleMultipleChange(value, 'selectedTaskStatus')}
            onBlur={this.handleMultipleSelect}
            onDeselect={value => this.handleTagsDelete(value, 'selectedTaskStatus')}
          >
            <Option key="All">
              All
            </Option>
            {_.isArray(taskStatusOptions) && taskStatusOptions.map(statusOption => (
              <Option key={statusOption.display_value}>
                {statusOption.display_value}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={2}>
          <Select
            className={classNames('full-width', 'taskList')}
            mode="multiple"
            tokenSeparators={[',']}
            value={selectedTaskPriority}
            onChange={value => this.handleMultipleChange(value, 'selectedTaskPriority')}
            onBlur={this.handleMultipleSelect}
            onDeselect={value => this.handleTagsDelete(value, 'selectedTaskPriority')}
          >
            <Option key="All">
              All
            </Option>
            {_.isArray(taskPriorityOptions) && taskPriorityOptions.map(priorityOption => (
              <Option key={priorityOption.display_value}>
                {priorityOption.display_value}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={2}>
          <FormattedMessage id="page.task.total" />: <span className={cx('total-weight')}>{taskDataTablePagination.total}</span>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ task, global, loginUser }) => {
  const { statuses, priorities } = global.settings;
  return {
    lang: global.language,
    taskStatusOptions: statuses,
    taskPriorityOptions: priorities,
    defaultTaskStatus: getDefautTaskStatus(global.settings),
    selectedStatus: task.selectedStatus,
    taskDataTablePagination: task.taskDataTablePagination,
    teamMembers: task.teamMembers,
    loginUser
  };
};

const mapDispatchToProps = {
  setPeriod,
  queryByPeriod,
  setTaskStatus,
  setActiveMember,
  queryFetch,
  queryByCondition,
  setTaskStatusQueryText,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopActions);



// WEBPACK FOOTER //
// ./src/views/Task/component/TopActions.jsx